import { render, staticRenderFns } from "./AssemblyBOM.vue?vue&type=template&id=23086bbe&scoped=true"
import script from "./AssemblyBOM.vue?vue&type=script&lang=js"
export * from "./AssemblyBOM.vue?vue&type=script&lang=js"
import style0 from "./AssemblyBOM.vue?vue&type=style&index=0&id=23086bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23086bbe",
  null
  
)

export default component.exports